import { defineMessages } from 'react-intl';

export default defineMessages({
  branchTypePlaceholder: {
    id: 'frontbucket.branches.branchTypePlaceholder',
    description: 'Placeholder for the branch type select on the branch list',
    defaultMessage: 'Branch type',
  },
  branchTypeValueLabelBugfix: {
    id: 'frontbucket.branches.branchTypeValueLabelBugfix',
    description: 'Label for bugfix branch type when selected in input',
    defaultMessage: 'Bugfix',
  },
  branchTypeValueLabelFeature: {
    id: 'frontbucket.branches.branchTypeValueLabelFeature',
    description: 'Label for feature branch type when selected in input',
    defaultMessage: 'Feature',
  },
  branchTypeValueLabelHotfix: {
    id: 'frontbucket.branches.branchTypeValueLabelHotfix',
    description: 'Label for hotfix branch type when selected in input',
    defaultMessage: 'Hotfix',
  },
  branchTypeValueLabelRelease: {
    id: 'frontbucket.branches.branchTypeValueLabelRelease',
    description: 'Label for release branch type when selected in input',
    defaultMessage: 'Release',
  },
  statusAll: {
    id: 'frontbucket.branches.statusAll',
    description: 'Text for the all branch status',
    defaultMessage: 'All branches',
  },
  statusActive: {
    id: 'frontbucket.branches.statusActive',
    description: 'Text for the active branch status',
    defaultMessage: 'Active branches',
  },
  statusMerged: {
    id: 'frontbucket.branches.statusMerged',
    description: 'Text for the merged branch status',
    defaultMessage: 'Merged branches',
  },
  statusStale: {
    id: 'frontbucket.branches.statusStale',
    description: 'Text for the stale branch status',
    defaultMessage: 'Stale branches',
  },
  searchPlaceholder: {
    id: 'frontbucket.branches.searchPlaceholder',
    description: 'Placeholder text to be shown in the branch list search input',
    defaultMessage: 'Search branches',
  },
});
